<fgb-page-header [pageTitle]="'payment.title'" [backButtonLink]="'/'"></fgb-page-header>

<fgb-banner [bannerTitle]="'payment.information' | translate"></fgb-banner>

<fgb-payment-nav></fgb-payment-nav>

<div class="container mt-4">
  <fgb-transaction-history [transactionTypes]="[transactionTypes.payment]" [ecashView]="true"></fgb-transaction-history>
</div>
